import React from 'react';

const TransportDetailModal = ({ transport, show, onClose }) => {
  const formatTime = (timeString) => {
    if (!timeString) return '';
    try {
      const date = timeString.includes('T') ? new Date(timeString) : new Date(`2000-01-01T${timeString}`);
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    } catch {
      return timeString;
    }
  };

  // Handle both old and new data structure
  const pickupTime = transport.pickup?.time || transport.pickup_time;
  const pickupLocation = transport.pickup?.location || transport.pickup_location;
  const dropoffLocation = transport.dropoff?.location || transport.destination || 'To Venue';
  const vehicleType = transport.vehicleInfo?.type || transport.vehicle_type;
  const driverName = transport.driver?.name || transport.driver;
  const driverPhone = transport.driver?.phone || transport.driver_phone;
  const company = transport.provider || transport.company;
  const confirmation = transport.confirmationNumber || transport.confirmation;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50" onClick={onClose}>
      <div 
        className="w-full max-w-[350px] mx-4 transform overflow-hidden rounded-2xl bg-[#1C1C1E] border border-[rgba(255,255,255,0.2)] text-left align-middle shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-6 border-b border-[rgba(255,255,255,0.1)]">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-white text-[18px] font-semibold">
              {show.venue?.name || show.venue}
            </h2>
            <button onClick={onClose} className="text-white text-[24px] hover:text-[rgba(255,255,255,0.7)]">×</button>
          </div>
          <p className="text-[rgba(255,255,255,0.6)] text-[12px]">
            {show.city || show.venue?.city}, {show.state || show.venue?.state}
          </p>
          <p className="text-[rgba(255,255,255,0.5)] text-[10px] mt-1">
            {show.show_date} {show.show_time}
          </p>
        </div>

        {/* Car Service Detail */}
        <div className="p-6 space-y-4">
          <div className="bg-[rgba(255,255,255,0.05)] rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div>
                <p className="text-white text-[18px] font-semibold">{formatTime(pickupTime)}</p>
                <p className="text-[rgba(255,255,255,0.6)] text-[12px]">{dropoffLocation}</p>
              </div>
              <span className="text-[24px]">🚗</span>
            </div>

            {pickupLocation && (
              <p className="text-[rgba(255,255,255,0.5)] text-[12px] mb-2">
                {pickupLocation}
              </p>
            )}
          </div>

          {/* Details */}
          <div className="space-y-3">
            {vehicleType && (
              <div className="flex justify-between text-[12px]">
                <span className="text-[rgba(255,255,255,0.6)]">Vehicle</span>
                <span className="text-white">{vehicleType}</span>
              </div>
            )}
            {driverName && (
              <div className="flex justify-between text-[12px]">
                <span className="text-[rgba(255,255,255,0.6)]">Drop</span>
                <span className="text-white">{driverName}</span>
              </div>
            )}
            {driverPhone && (
              <div className="flex justify-between text-[12px]">
                <span className="text-[rgba(255,255,255,0.6)]">Contact</span>
                <span className="text-white">{driverPhone}</span>
              </div>
            )}
            {company && (
              <div className="flex justify-between text-[12px]">
                <span className="text-[rgba(255,255,255,0.6)]">Company</span>
                <span className="text-white">{company}</span>
              </div>
            )}
            {confirmation && (
              <div className="flex justify-between text-[12px]">
                <span className="text-[rgba(255,255,255,0.6)]">Confirmation #</span>
                <span className="text-white">{confirmation}</span>
              </div>
            )}
            {transport.status && (
              <div className="flex justify-between text-[12px]">
                <span className="text-[rgba(255,255,255,0.6)]">Status</span>
                <span className={`${transport.status === 'confirmed' ? 'text-[#34C759]' : 'text-white'}`}>
                  {transport.status.charAt(0).toUpperCase() + transport.status.slice(1)}
                </span>
              </div>
            )}
          </div>

          {transport.notes && (
            <div className="bg-[rgba(255,255,255,0.05)] rounded-lg p-3">
              <p className="text-[rgba(255,255,255,0.5)] text-[10px]">{transport.notes}</p>
            </div>
          )}

          {/* Action Button */}
          <button
            onClick={onClose}
            className="w-full bg-[#FF9500] text-white border-none rounded-lg px-5 py-3 text-[12px] font-semibold cursor-pointer transition-colors hover:bg-[#FF8800]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransportDetailModal;

